import { api } from '../../../lib/api.js';

export async function fetchProducts() {
  const res = await api.get('products');
  return res.data;
}

export async function fetchRelatedProducts() {
  const res = await api.get('relatedproducts');
  return res.data;
}

export async function fetchProductDetails(productId) {
  const res = await api.get(`products/${productId}`);
  return res.data;
}

export async function validateCoupon(code, productId) {
  const res = await api.get(`coupon/${code}/${productId}`);
  return res.data;
}

export async function startPayment(body) {
  const res = await api.post('startpayment', body);
  return res.data;
}

export async function logPayment(logData) {
  const res = await api.post('log_payment', { log_data: logData });
  return res.data;
}

export async function processPayment(orderId, paymentType) {
  const res = await api.post('processpayment', {
    ORDERID: orderId,
    ISWEB: 'yes',
    payment_type: paymentType,
  });
  return res.data;
}
